module.exports = __webpack_public_path__ + "static/media/chery.de700941.png";